import { render, staticRenderFns } from "./UserValidation.vue?vue&type=template&id=32ebf67c&scoped=true"
import script from "./UserValidation.vue?vue&type=script&lang=js"
export * from "./UserValidation.vue?vue&type=script&lang=js"
import style0 from "./UserValidation.vue?vue&type=style&index=0&id=32ebf67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebf67c",
  null
  
)

export default component.exports